module.exports = __webpack_public_path__ + "img/cash-bordered.0cf7a00c.svg";